export default "__VITE_ASSET__CMlfHYUM__"